module.exports = __webpack_public_path__ + "img/works-07_ps-kobayashi.81412d19.png";